export const emailRoutesMap = {
  gestion: {
    path: '/empresa/email',
    name: 'Gestión de Clientes de Correo',
  },
  nuevo: {
    path: '/empresa/email/nuevo',
    name: 'Nuevo Registro',
  },
  modificar: {
    path: `/empresa/email/modificar`,
    name: 'Actualizar Registro',
  },
}
